<template lang="pug">
  b-row
    b-col.mb-2(cols="12" md="3")
      state-count-card(
        stateName = "Planillas Faltantes"
        color="#3498DB"
        icon="pending_actions"
        :stateCount="countStatesWithdrawal['no asignados']"
      )
    b-col.mb-2(cols="12" md="3")
      state-count-card(
        stateName = "Planillas OK"
        color="#3DF9DE"
        icon="checklist"
        :stateCount="countStatesWithdrawal['asignados']"
      )
    b-col(cols="12" md="3")
      state-count-card(
        stateName = "Planillas Totales"
        color="#9B59B6"
        icon="content_paste"
        :stateCount="countStatesWithdrawal['todos']"
      )
</template>

<script>
import StateCountCard from '../UI/StateCountCard.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'WithdrawalStateCards',
  components: {
    StateCountCard
  },
  computed: {
    ...mapGetters(['countStatesWithdrawal'])
  }
}
</script>
